export const APP_LOG_CONTEXT_STORAGE_KEY = 'app-log-context';
